import { localeSettingsService } from '@/services/locale-settings.service'

/**
 * Offer Wizard Step 3's consumer-owned view of the tenant's locales (TO-124 REQ-009).
 * The step depends on this port only — never on the product editor's locale hooks.
 */
export interface LocalePort {
	/** The tenant's enabled locale tags in configured order; `[]` when unreadable, unconfigured or no slug. */
	listEnabledLocales(tenantSlug: string | null): Promise<string[]>
}

/** The HTTP adapter: `GET /t/{slug}/admin/settings/locale` for the viewer's session slug (needs `tenant.read`). */
export const httpLocalePort: LocalePort = {
	async listEnabledLocales(tenantSlug) {
		if (!tenantSlug) return []
		try {
			return (await localeSettingsService.get(tenantSlug)).enabledLocales
		} catch {
			// A refused read (e.g. no tenant.read) counts as no locales: the switch keeps the offer's own.
			return []
		}
	},
}
